<template>
  <b-row class="base-row-padded">
    <b-col>
      <GroupsViewer />
    </b-col>
  </b-row>
</template>

<script>
import GroupsViewer from '@/components/GroupsViewer.vue';

export default {
  components: { GroupsViewer },
};
</script>
